import { primary } from '@automata/mui-theme/src/colors';
import { SxProps, Theme } from '@mui/material';

const BORDER_COLOR = '#ccc';
const PRIMARY_BLUE = primary[600];
const HOVER_BG = '#f0f0f0';
const SUCCESS_BG = '#f0fdf4';
const ERROR_BG = '#fff5f5';

export const styles = {
  container: {
    width: '100%',
    mt: 2,
  } satisfies SxProps<Theme>,

  header: {
    fontSize: 30,
    color: PRIMARY_BLUE,
  } satisfies SxProps<Theme>,

  dropZone: (isEditable: boolean): SxProps<Theme> => ({
    border: `2px dashed ${BORDER_COLOR}`,
    borderRadius: 2,
    py: 6,
    px: 4,
    textAlign: 'center',
    cursor: isEditable ? 'pointer' : 'no-drop',
    '&:hover': {
      backgroundColor: isEditable ? HOVER_BG : undefined,
    },
  }),

  fileIcon: {
    fontSize: 40,
    opacity: 0.6,
    backgroundColor: HOVER_BG,
    borderRadius: '50%',
    padding: '8px',
  } satisfies SxProps<Theme>,

  uploadCard: {
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: 2,
    backgroundColor: '#fff',
  } satisfies SxProps<Theme>,

  cardHeader: {
    px: 2,
    py: 2,
    borderBottom: `1px solid ${BORDER_COLOR}`,
    minHeight: '73px',
  } satisfies SxProps<Theme>,

  fileInfoText: {
    color: PRIMARY_BLUE,
  } satisfies SxProps<Theme>,

  uploadStatusRow: {
    py: 2,
  } satisfies SxProps<Theme>,

  statusBadge: (bg: string, color: string): SxProps<Theme> => ({
    backgroundColor: bg,
    color,
    px: 1.5,
    py: 0.5,
    borderRadius: 2,
    fontWeight: 500,
  }),

  successBox: {
    backgroundColor: SUCCESS_BG,
    p: 2,
  } satisfies SxProps<Theme>,

  downloadLink: {
    color: '#1976d2',
    fontSize: '0.875rem',
    textDecoration: 'underline',
  } satisfies SxProps<Theme>,

  errorBox: {
    backgroundColor: ERROR_BG,
    p: 2,
  } satisfies SxProps<Theme>,

  errorIcon: {
    color: '#c62828',
    fontSize: 30,
  } satisfies SxProps<Theme>,

  completeIcon: {
    color: '#2e7d32',
    fontSize: 30,
  } satisfies SxProps<Theme>,

  actionButton: {
    color: '#5d4037',
  } satisfies SxProps<Theme>,
};
